<template>
    <div class="modal fade" id="table-config">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close">
                        <span
                            aria-hidden="true">
                            &times;
                        </span>
                    </button>
                    <h4 class="modal-title">Configurar Listado</h4>
                </div>
                <div class="modal-body">
                    <div class="col-xs-12 col-lg-6">
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="id">
                            <label for="checkbox1">ID de oferta</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="title">
                            <label for="checkbox1">Título</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="offersProvider">
                            <label for="checkbox2">Proveedor</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="description">
                            <label for="checkbox3">Descripción</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="total_due_amount">
                            <label for="checkbox4">Total a pagar</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" v-model="visibleColumns" value="created_at">
                            <label for="checkbox5">Fecha de creación</label>
                        </div>
                        <div class="checkbox check-default">
                            <input
                                type="checkbox"
                                checked="checked"
                                v-model="visibleColumns"
                                value="comission_percent">
                            <label for="checkbox6">Comisión</label>
                        </div>
                        <div class="checkbox check-default">
                            <input
                                type="checkbox"
                                checked="checked"
                                v-model="visibleColumns"
                                value="comission_percent">
                            <label for="checkbox6">Ganancia por Comisión</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="valor">
                            <label for="checkbox6">Valor de la oferta</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="client_counts">
                            <label for="checkbox6">Cantidad de Clientes</label>
                        </div>
                    </div>
                    <div class="col-xs-12 col-lg-6">
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="offersStatus">
                            <label for="checkbox8">Estado de oferta</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="due_date">
                            <label for="checkbox10">Fecha de vencimiento</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" v-model="visibleColumns" value="start_date">
                            <label for="checkbox12">Fecha de inicio</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" v-model="visibleColumns" value="validity">
                            <label for="checkbox13">Vigencia de la oferta</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="discount_percent">
                            <label for="checkbox14">Descuento</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="offersType">
                            <label for="checkbox14">Tipo de Oferta</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="serviceType">
                            <label for="checkbox14">Segmento</label>
                        </div>
                        <div class="checkbox check-default">
                            <input type="checkbox" checked="checked" v-model="visibleColumns" value="fee">
                            <label for="checkbox6">Cuotas</label>
                        </div>
                    </div>
                    <div class="clearfix"></div>
                </div>
                <div class="modal-footer text-center">
                    <div class="row">
                        <div class="col-md-12">
                            <a data-dismiss="modal" class="btn btn-bgrey">CANCELAR</a>
                            <a data-dismiss="modal" class="btn btn-success">APLICAR</a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
    <!-- FOOTER   -->
    <footer class="footer b-t b-grey">
        <div class="copyright">2016 &copy; Cash Depot - Todos los derechos reservados.</div>
    </footer>
    <div>
        <!-- OLD DIV VERSION    <div class="col-md-10 col-sm-9 col-md-offset-2 col-sm-offset-3 content container-fluid">-->
        <div class="col-xs-12 content container-fluid">
            <div class="wrapper">
                <div class="container-wrapper">
                    <div id="alerts-container">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <a
                        :disabled="loadingTable"
                        class="btn btn-default pull-right"
                        href="/#!/create-offer">
                        <span
                            class="glyphicon glyphicon-plus">
                        </span> Crear Oferta
                    </a>
                    <a
                        :disabled="loadingTable"
                        class="btn btn-default pull-right"
                        href="/#!/create-provider">
                        <span
                            class="glyphicon glyphicon-plus">
                        </span> Crear Proveedor
                    </a>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 m-t-20">
                    <div class="col-xs-12 b-t b-dashed b-transparent">
                        <div class="col-xs-12 col-lg-4 m-t-20">
                            <h4 class="tex-cdi-primary">VENTAS</h4>
                            <h2 class="tex-cdi-primary m-0">RD{{ total_sold | currency }}</h2>
                        </div>
                        <div class="col-xs-12 col-lg-4  b-l b-dashed b-transparent m-t-20">
                            <h4 class="tex-cdi-primary">COSTOS</h4>
                            <h2 class="tex-cdi-primary m-0">RD{{ accounts_to_pay | currency }}</h2>
                            <p class="tex-cdi-primary">({{ getDate }})</p>
                        </div>
                        <div class="col-xs-12 col-lg-4 b-l b-dashed b-transparent m-t-20">
                            <h4 class="tex-cdi-primary">INGRESOS</h4>
                            <h2 class="tex-cdi-primary m-0">RD{{ accounts_to_charge | currency }}</h2>
                            <p class="tex-cdi-primary">({{ getDate }})</p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="app" class="ui vertical stripe segment">
                <div class="col-xs-12 m-t-20">
                    <div class="input-group transparent col-xs-12 col-lg-6  p-r-5 m-b-20 pull-left">
                        <input
                            :disabled="loadingTable"
                            type="text"
                            class="form-control f-text-md"
                            v-model="filterText"
                            @keypress.enter="getOffers()"
                            placeholder="Buscar: ofertas"
                            id="search-btn"
                            name="search-btn">
                        <span class="input-group-addon bg-white">
                        <i
                            :disabled="loadingTable"
                            @click="getOffers()"
                            class="md md-search sm-ico">
                        </i>
                        </span>
                    </div>
                    <button
                        class="btn btn-default download-table-btn"
                        :disabled="loadingTable"
                        @click="exportTable()">
                        <span class="glyphicon glyphicon-download-alt"></span>
                        DESCARGAR
                    </button>
                    <button
                        class="btn btn-default download-table-btn"
                        :disabled="loadingTable"
                        data-toggle="modal"
                        data-target="#table-config">
                        <span class="glyphicon glyphicon-cog"></span> CONFIGURACiÓN
                    </button>
                    <button
                        v-show="false"
                        class="btn btn-primary dropdown-toggle m-l-5"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        id="dropdownfilter">
                        <i class="md md-tune sm-ico b-r b-white p-r-20 m-r-20"></i> FILTRAR
                    </button>
                    <div class="dropdown-menu filter-menu" aria-labelledby="dropdownfilter">
                        <div class="col-xs-12">
                            <div class="form-group col-xs-12 col-lg-4">
                                <h5>Tipo de oferta</h5>
                                <select
                                    class="full-width select2-hidden-accessible"
                                    data-init-plugin="select2"
                                    tabindex="-1"
                                    aria-hidden="true">
                                    <optgroup>
                                        <option>Todas</option>
                                        <option>60</option>
                                        <option>90</option>
                                    </optgroup>
                                </select>
                                <span
                                    class="select2 select2-container select2-container--default"
                                    dir="ltr"
                                    style="width: 100%;">
                                    <span class="selection">
                                        <span
                                            class="select2-selection select2-selection--single"
                                            role="combobox"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            tabindex="0"
                                            aria-labelledby="select2-8n8j-container">
                                            <span
                                                class="select2-selection__rendered"
                                                id="select2-8n8j-container"
                                                title="Todas">Todas
                                            </span>
                                                <span
                                                    class="select2-selection__arrow"
                                                    role="presentation">
                                                        <b role="presentation"></b>
                                                </span>
                                            </span>
                                        </span>
                                        <span
                                            class="dropdown-wrapper"
                                            aria-hidden="true">
                                        </span>
                                    </span>
                            </div>
                            <div class="form-group col-xs-12 col-lg-4">
                                <h5>Método de pago</h5>
                                <select
                                    class="full-width select2-hidden-accessible"
                                    data-init-plugin="select2"
                                    tabindex="-1"
                                    aria-hidden="true">
                                    <optgroup>
                                        <option>Todos</option>
                                        <option>60</option>
                                        <option>90</option>
                                    </optgroup>
                                </select>
                                <span
                                    class="select2 select2-container select2-container--default"
                                    dir="ltr"
                                    style="width: 100%;">
                                    <span class="selection">
                                        <span
                                            class="select2-selection select2-selection--single"
                                            role="combobox"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            tabindex="0"
                                            aria-labelledby="select2-fjgl-container">
                                            <span
                                                class="select2-selection__rendered"
                                                id="select2-fjgl-container"
                                                title="Todos">Todos
                                            </span>
                                                <span
                                                    class="select2-selection__arrow"
                                                    role="presentation">
                                                        <b role="presentation"></b>
                                                </span>
                                            </span>
                                        </span>
                                        <span
                                            class="dropdown-wrapper"
                                            aria-hidden="true">
                                        </span>
                                    </span>
                            </div>
                            <div class="form-group col-xs-12 col-lg-4">
                                <h5>Estado de oferta</h5>
                                <select
                                    class="full-width select2-hidden-accessible"
                                    data-init-plugin="select2"
                                    tabindex="-1"
                                    aria-hidden="true">
                                    <optgroup>
                                        <option>Todos</option>
                                        <option>60</option>
                                        <option>90</option>
                                    </optgroup>
                                </select>
                                <span
                                    class="select2 select2-container select2-container--default"
                                    dir="ltr"
                                    style="width: 100%;">
                                    <span class="selection">
                                        <span
                                            class="select2-selection select2-selection--single"
                                            role="combobox"
                                            aria-haspopup="true"
                                            aria-expanded="false"
                                            tabindex="0"
                                            aria-labelledby="select2-ocxo-container">
                                            <span
                                                class="select2-selection__rendered"
                                                id="select2-ocxo-container"
                                                title="Todos">
                                                Todos
                                            </span>
                                            <span
                                                class="select2-selection__arrow"
                                                role="presentation">
                                                <b role="presentation"></b>
                                            </span>
                                        </span>
                                    </span>
                                    <span
                                        class="dropdown-wrapper"
                                        aria-hidden="true">
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-xs-12 m-t-20">
                        <div class="table-responsive">
                            <div id="content" class="ui basic segment">
                                <table
                                    id="table-with-sorting"
                                    class="table data-table with-sorting table-striped tablesorter payment-batch-table
                                           sortable">
                                    <thead>
                                        <tr>
                                            <th style="width: 40px;"></th>
                                            <th v-show="showElement('id')">
                                                <span @click="sort('id',false)">
                                                    Id
                                                    <span v-show="sortBy == 'id'" :class="getSortIcon()"></span>
                                                </span>
                                            </th>
                                            <th v-show="showElement('offersStatus')">Estado</th>
                                            <th v-show="showElement('offersProvider')">Proveedor</th>
                                            <th v-show="showElement('title')">
                                                <span @click="sort('title',true)">
                                                    Título
                                                    <span v-show="sortBy == 'title'" :class="getSortIcon()">
                                                </span>
                                            </th>
                                            <th v-show="showElement('description')" style="width: 300px;">
                                                <span @click="sort('description',true)">
                                                    Descripción
                                                <span v-show="sortBy == 'description'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('offersType')" >
                                                <span>
                                                    Tipo de Oferta
                                                <span v-show="sortBy == 'id'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('serviceType')">
                                                <span @click="sort('due_date',true)">
                                                    Segmento
                                                <span v-show="sortBy == 'due_date'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('valor')">
                                                <span @click="sort('due_date',true)">
                                                    Valor
                                                <span v-show="sortBy == 'due_date'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('client_counts')">
                                                <span @click="sort('client_counts',true)">
                                                    Cant. Clientes
                                                <span v-show="sortBy == 'client_counts'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('total_due_amount')">
                                                <span @click="sort('total_due_amount',false)">
                                                    Total a Pagar
                                                <span v-show="sortBy == 'total_due_amount'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('fee')">
                                                <span @click="sort('fee',true)">
                                                    Cuotas
                                                <span v-show="sortBy == 'fee'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('discount_percent')">
                                                <span @click="sort('discount_percent',false)">
                                                    Descuento
                                                <span v-show="sortBy == 'discount_percent'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('comission_percent')">
                                                <span @click="sort('comission_percent',false)">
                                                    Comisión
                                                <span v-show="sortBy == 'comission_percent'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('comission_percent')">
                                                <span @click="sort('comission_percent',false)">
                                                    Ganancia por Comisión
                                                <span v-show="sortBy == 'comission_percent'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('created_at')">
                                                <span @click="sort('description',false)">
                                                    Fecha de Creación
                                                <span v-show="sortBy == 'id'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('start_date')">
                                                <span @click="sort('start_date',true)">
                                                    Fecha de Inicio
                                                <span v-show="sortBy == 'start_date'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('validity')" >
                                                <span @click="sort('validity',true)">
                                                    Vigencia
                                                <span v-show="sortBy == 'validity'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th v-show="showElement('due_date')">
                                                <span @click="sort('due_date',true)">
                                                    Fecha de Vencimiento
                                                <span v-show="sortBy == 'due_date'" :class="getSortIcon()"> </span>
                                            </th>
                                            <th>
                                                <i class="md md-more-vert sm-ico"></i>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="!loadingTable">
                                        <tr v-for="offer in offers">
                                            <td>
                                                <input
                                                    :value="offer"
                                                    v-model="checkedOffers"
                                                    type="checkbox">
                                            </td>
                                            <td
                                                v-show="showElement('id')"
                                                v-link="{ name: 'new-client-offers', params: { id: offer.id }}">
                                                <a>
                                                    #{{ offer.id }}
                                                </a>
                                            </td>
                                            <td v-show="showElement('offersStatus')">
                                                <a href="/#!/edit-offer/{{offer.id}}">{{ offer.offersStatus.name }}</a>
                                            </td>
                                            <td v-show="showElement('offersProvider')">
                                                {{ offer.offersProvider.name }}
                                            </td>
                                            <td v-show="showElement('title')">
                                                {{ offer.title }}
                                            </td>
                                            <td v-show="showElement('description')">
                                                {{ offer.description }}
                                            </td>
                                            <td v-show="showElement('offersType')">
                                                {{ offer.offersType.name }}
                                            </td>
                                            <td v-show="showElement('serviceType')">
                                                {{ offer.serviceType.name }}
                                            </td>
                                            <td v-show="showElement('valor')">
                                                {{ offer.amount }}
                                            </td>
                                            <td v-show="showElement('client_counts')">
                                                {{offer.client_counts}}
                                            </td>
                                            <td v-show="showElement('total_due_amount')">
                                                {{ offer.total_due_amount}}
                                            </td>
                                            <td v-show="showElement('fee')">
                                                {{ offer.fee ? offer.fee : 0  }}
                                            </td>
                                            <td v-show="showElement('discount_percent')">
                                                {{ offer.discount_percent ? offer.discount_percent : 0}}%
                                            </td>
                                            <td v-show="showElement('comission_percent')">
                                                {{ offer.comission_percent ? offer.comission_percent : 0}}%
                                            </td>
                                            <td v-show="showElement('comission_percent')">
                                                {{ offer.comission_gain ?  offer.comission_gain: 0}}
                                            </td>
                                            <td v-show="showElement('start_date')">
                                                {{ offer.start_date | dateFormat }}
                                            </td>
                                            <td v-show="showElement('due_date')">
                                                {{ offer.due_date | dateFormat }}
                                            </td>
                                            <td v-show="showElement('created_at')">
                                                {{ offer.created_at | dateFormat }}
                                            </td>
                                            <td v-show="showElement('validity')">
                                                {{ offer.validity == 1 ? 'Temporal' : 'Indefinida' }}
                                            </td>
                                            <td>
                                                <a
                                                    @click="setSelectedOffer(offer)"
                                                    class="tex-cdi-primary toggle_popover_manual"
                                                    data-container="body"
                                                    data-toggle="popover"
                                                    data-placement="left"
                                                    data-content=""
                                                    data-original-title=""
                                                    title="">
                                                    <i class="md md-more-vert sm-ico"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot v-show="!loadingTable">
                                        <tr>
                                            <th colspan="12">
                                                <div class="row">
                                                    <div class="col-xs-12">
                                                        <pagination
                                                            :total="total"
                                                            :page-size="pageSize"
                                                            :callback="pageChanged"
                                                            :options="paginationOptions"
                                                            nav-class="padding-10"
                                                            ul-class="bg-color-red"
                                                            li-class="txt-color-blue">
                                                        </pagination>
                                                    </div>
                                                </div>
                                            </th>
                                        </tr>
                                    </tfoot>
                                </table>
                                <template v-if="loadingTable">
                                    <div style="text-align:center">
                                        <span class="fa fa-spin fa-spinner"></span>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <!--</div>-->
                    </div>
                </div>
            </div>
            <!--      ACTION DATA TOGGLE   -->
            <div id="popover-content" class="hide">
                <ul class="padding-5">
                    <li class="b-b b-grey p-b-5 m-b-15">
                        <a
                            data-toggle="modal"
                            data-target="#new-offer"
                            class="tex-cdi-primary">
                            <i class="md md-mode-edit m-r-10 sm-ico"></i>
                            Editar
                        </a>
                    </li>
                    <li class="b-b b-grey p-b-5 m-b-15">
                        <a
                            class="tex-cdi-primary"
                            data-toggle="modal"
                            data-target="#archiveModal">
                            <i class="md md-archive m-r-10 sm-ico"></i>
                            Archivar
                        </a>
                    </li>
                    <li class="b-b b-grey p-b-5 m-b-15">
                        <a
                            class="tex-cdi-primary"
                            data-toggle="modal"
                            data-target="#UnarchiveModal">
                            <i class="md md-archive m-r-10 sm-ico"></i>
                            Desarchivar
                        </a>
                    </li>
                    <li>
                        <a
                            class="tex-cdi-primary"
                            data-toggle="modal"
                            data-target="#eraseArchiveModal">
                            <i class="md md-delete m-r-10 sm-ico"></i>
                            Eliminar
                        </a>
                    </li>
                </ul>
            </div>
            <!--     ACTION DATA TOGGLE   -->
        </div>
    </div>
    <!-- CREATE OFFERS -->
    <create-edit-offers :operation="modalOperation" :offer="selectedOffer"></create-edit-offers>
    <!-- Modal -->
    <div class="modal fade" id="eraseArchiveModal" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">Confirmación</h4>
                </div>
                <div class="modal-body">
                    <p>Â¿Borrar esta oferta?</p>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal"
                        @click="deleteOffer()">
                        Borrar
                    </button>
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="UnarchiveModal" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">Confirmación</h4>
                </div>
                <div class="modal-body">
                    <p>¿Desarchivar esta oferta?</p>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal"
                        @click="unarchiveOffer()">
                        Desarchivar
                    </button>
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="archiveModal" role="dialog">
        <div class="modal-dialog">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                    <h4 class="modal-title">Confirmación</h4>
                </div>
                <div class="modal-body">
                    <p>¿Archivar esta oferta?</p>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal"
                        @click="archiveOffer()">
                        Archivar
                    </button>
                    <button
                        type="button"
                        class="btn btn-default"
                        data-dismiss="modal">
                        Cerrar
                    </button>
                </div>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
import Pagination from "../utilities/pagination.vue";
export default {
  data() {
    return {
      api_url: `http://apidev.cashdepotint.com/v1`,
      total_sold: "",
      accounts_to_pay: "",
      accounts_to_charge: "",
      currentPage: 1,
      title: "",
      checkedOffers: [],
      description: "",
      filterText: "",
      startDate: "",
      due_date: "",
      validity: "",
      amount: 0,
      cost: 0,
      modalOperation: "create",
      comission_percent: "",
      discount_percent: "",
      fee: "",
      type: [],
      columnTitles: {
        id: "Id",
        title: "Título",
        description: "Descripción",
        discount_percent: "Descuento",
        created_at: "Fecha de Creación",
        offersProvider: "Proveedor",
        client_counts: "Cantidad de Clientes",
        total_due_amount: "Total a Pagar",
        comission_percent: "Comisión",
        status: "Estado",
        offersType: "Tipo de Oferta",
        validity: "Vigencia de la Oferta",
        start_date: "Fecha de Inicio",
        offersStatus: "Estado",
        due_date: "Fecha de Vencimiento",
        serviceType: "Tipo de Servicio",
        fee: "Cuotas",
      },
      categories: [],
      loadingTable: true,
      serviceType: [],
      selectedType: 0,
      selectedServiceType: "",
      selectedCategory: "",
      selectedOffer: {},
      total: 1000,
      pageSize: 50,
      paginationOptions: {
        // Not required to pass this configurations
        offset: 1,
        previousText: "Anterior",
        nextText: "Siguiente",
        alwaysShowPrevNext: true,
      },
      providers: [],
      provider: "",
      selectedProvider: "",
      sortBy: "id",
      sortOrder: "DESC",
      days: 0,
      offers: [],
      imagen: null,
      internOffer: "",
      imageSrc: "",
      moreParams: ["q=(is_deleted:0)"],
      visibleColumns: [],
      vid: false,
      selectedColumns: "",
      user_id: "",
    };
  },
  watch: {
    selectedServiceType: function () {
      if (this.selectedServiceType) {
        this.setCategories();
      }
    },
    offers() {
      $(".popover").popover("hide");
      $("[data-toggle=popover]").popover({
        html: true,
        trigger: "manual",
        content: () => {
          $(".popover").popover("hide");
          return $("#popover-content").html();
        },
      });
    },
  },
  filters: {
    dateFormat: function (date) {
      return moment(date).format("DD/MM/YYYY");
    },
  },
  components: {
    Pagination,
  },
  created() {
    this.user_id = this.$route.query.id;

    if (!this.user_id) {
      this.user_id = window.localStorage.getItem("user_id");
    } else {
      window.localStorage.setItem("user_id", this.user_id);
    }
    console.log(this.user_id);
    this.getTotalSold();
    this.getAccountsToCharge();
    this.getAccountsToPay();
    this.getProviders();
    this.getOfferType();
    this.getOfferServiceType();
    this.getOffers();

    $(document).on("click", ".toggle_popover_manual", function () {
      $(this).popover("toggle");
    });
  },
  methods: {
    archiveOffer() {
      let data = {};
      data.status_id = 2;
      $.ajax({
        url: apiUrl + `/offers/${this.selectedOffer.id}`,
        type: "PUT",
        data: data,
        contentType: "application/x-www-form-urlencoded",
        success: (data) => {
          swal(
            {
              title: "Â¡Listo!",
              text: "Â¡Oferta archivada exitosamente!",
              type: "success",
            },
            () => {
              this.getOffers(this.currentPage);
            }
          );
        },
        error: function (data) {
          sweetAlert(
            "Oops...",
            "Â¡Ha ocurrido un error al borrar la oferta! " +
              response.status.message,
            "error"
          );
        },
      });
    },
    unarchiveOffer() {
      let data = {};
      data.status_id = 1;
      $.ajax({
        url: apiUrl + `/offers/${this.selectedOffer.id}`,
        type: "PUT",
        data: data,
        contentType: "application/x-www-form-urlencoded",
        success: (data) => {
          swal(
            {
              title: "Â¡Listo!",
              text: "Â¡Oferta desarchivada exitosamente!",
              type: "success",
            },
            () => {
              this.getOffers(this.currentPage);
            }
          );
        },
        error: function (data) {
          sweetAlert(
            "Oops...",
            "Â¡Ha ocurrido un error al borrar la oferta! " +
              response.status.message,
            "error"
          );
        },
      });
    },
    cleanFields() {
      this.title = "";
      this.description = "";
      this.startDate = "";
      this.comission_percent = "";
      this.discount_percent = "";
      this.selectedCategory = "";
      this.selectedType = 0;
      this.selectedServiceType = 0;
      this.selectedProvider = 0;
      this.amount = "";
      this.cost = "";
      this.days = "";
      this.fee = "";
      this.validity = "";
      this.due_date = "";
    },
    deleteOffer() {
      let data = {};
      data.is_deleted = 1;
      $.ajax({
        url: apiUrl + `/offers/${this.selectedOffer.id}`,
        type: "PUT",
        data: data,
        contentType: "application/x-www-form-urlencoded",
        success: (data) => {
          swal(
            {
              title: "Â¡Listo!",
              text: "Â¡Oferta eliminada exitosamente!",
              type: "success",
            },
            () => {
              this.getOffers(this.currentPage);
            }
          );
        },
        error: function (data) {
          sweetAlert(
            "Oops...",
            "Â¡Ha ocurrido un error al borrar la oferta! " +
              response.status.message,
            "error"
          );
        },
      });
    },
    returnId: function (value) {
      return value;
    },
    sync: function (event, tipo) {
      event.preventDefault();
      this[tipo] = event.target.files[0] || event.dataTransfer.files[0];

      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (event) => {
        vm.imageSrc = event.target.result;
      };

      reader.readAsDataURL(this[tipo]);
    },
    returnStatus: function (value) {
      return value;
    },
    returnProvider: function (value) {
      return value;
    },

    returnTitle: function (value) {
      return value;
    },

    returnDescription: function (value) {
      return value;
    },

    returnCreationDate: function (value) {
      return value;
    },

    viewProfile: function (id) {
      console.log("view profile with id:", id);
    },

    getAccountsToPay: function () {
      this.$http.get(apiUrl + "/offers/accounts-to-pay").then(
        (response) => {
          this.accounts_to_pay = response.data;
        },
        (response) => {
          sweetAlert("Oops...", "Ha ocurrido un error !", "error");
        }
      );
    },
    hideAllPopovers() {
      $('[data-toggle="popover"]').each(function () {
        $(this).popover("hide");
      });
    },
    getOffers: function (page = 1) {
      let params = "";
      if (this.filterText) {
        params = `,title:${this.filterText}%`;
      }
      this.loadingTable = true;
      this.$http
        .get(
          apiUrl +
            `/offers?relationships=offersProvider,offersStatus,offersType,serviceType,categories&q=(is_deleted:0${params})&format=true&limit=100&page=${page}&sort=${this.sortBy}|${this.sortOrder}`
        )
        .then((response) => {
          this.offers = response.body.data;
          this.total = response.body.total_pages * 50;
          this.loadingTable = false;
        });
    },
    getTotalSold: function () {
      this.$http.get(apiUrl + "/offers/total-sold").then((response) => {
        this.total_sold = response.data;
        //this.total_sold = 0;
      });
    },
    getAccountsToCharge: function () {
      this.$http.get(apiUrl + "/offers/accounts-to-charge").then(
        (response) => {
          //this.accounts_to_charge = 0;
          this.accounts_to_charge = response.data;
        },
        (response) => {
          sweetAlert("Oops...", "Ha ocurrido un error !", "error");
        }
      );
    },

    displayOffer: function () {
      this.modalOperation = "create";
      this.selectedOffer = {};
      $("#new-offer").modal("show");
      $("#first-date").datepicker({
        minDate: -20,
        maxDate: "+1M +10D",
      });
      $("#last-date").datepicker();
    },

    getProviders: function () {
      this.$http.get(apiUrl + "/providers").then(
        (response) => {
          this.providers = response.data;
        },
        (response) => {
          sweetAlert(
            "Oops...",
            "Ha ocurrido un error al cargar los proovedores !",
            "error"
          );
        }
      );
    },

    getSortIcon() {
      if (this.sortOrder == "ASC") {
        return "glyphicon glyphicon-chevron-up";
      }
      return "glyphicon glyphicon-chevron-down";
    },

    getOfferType: function () {
      this.$http.get(apiUrl + "/offer-types").then(
        (response) => {
          this.type = response.data;
        },
        (response) => {
          sweetAlert("Oops...", "Ha ocurrido al cargar los estados !", "error");
        }
      );
    },
    getOfferServiceType: function () {
      this.$http.get(apiUrl + "/service-types?relationships=categories").then(
        (response) => {
          this.serviceType = response.data;
        },
        (response) => {
          sweetAlert("Oops...", "Ha ocurrido al cargar los estados !", "error");
        }
      );
    },
    createOffer: function () {
      let data = new FormData();

      data.append("title", this.title);
      data.append("description", this.description);
      data.append("start_date", moment(this.startDate).format("YYYY-MM-DD"));
      data.append("due_date", moment(this.due_date).format("YYYY-MM-DD"));
      data.append("validity", this.validity);
      data.append("comission_percent", this.comission_percent);
      data.append("discount_percent", this.discount_percent);
      data.append("status_id", 1);
      data.append("fee", this.fee);
      data.append("days_id", this.days);
      data.append("categories_id", this.selectedCategory);
      data.append("type_id", this.selectedType);
      data.append("service_type_id", this.selectedServiceType);
      data.append("provider_id", this.selectedProvider);
      data.append("intern", 1);
      data.append("image", this.imagen);
      data.append("amount", this.amount);
      data.append("cost", this.cost);

      this.$http({
        emulateJSON: true,
        emulateHTTP: true,
        url: apiUrl + "/offers",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: data,
      }).then(
        (response) => {
          this.$broadcast("vuetable:refresh");
          console.log("Hi");
          // swal("Felicidades !", "Oferta creada exitosamente !", "success");
          this.cleanFields();
          $("#new-offer").modal("toggle");
        },
        (response) => {
          sweetAlert(
            "Oops...",
            "Ha ocurrido un error al crear la oferta ! " +
              response.status.message,
            "error"
          );
        }
      );

      //get new data
      // this.$broadcast('vuetable:reload');
    },
    showElement(elementName) {
      return this.visibleColumns.includes(elementName);
    },
    setSelectedOffer(offer) {
      this.modalOperation = "edit";
      this.selectedOffer = offer;
    },
    loadOfferPage(offerId) {
      this.$router.push({
        name: "new-client-offers",
        params: {
          id: offerId,
        },
      });
    },
    /**
     * Prepares the data and exports the current page table or the selected offers
     */
    exportTable() {
      let temporaryOffersList = this.offers;
      let formattedOffersList = [];

      if (this.checkedOffers.length) {
        temporaryOffersList = this.checkedOffers;
      }

      for (let i = 0; i < temporaryOffersList.length; i++) {
        let temporaryContact = {};

        for (let j = 0; j < this.visibleColumns.length; j++) {
          let columnName = this.columnTitles[this.visibleColumns[j]];

          if (_.isObject(temporaryOffersList[i][this.visibleColumns[j]])) {
            if (columnName) {
              temporaryContact[columnName] =
                temporaryOffersList[i][this.visibleColumns[j]].name;
            } else {
              temporaryContact[this.visibleColumns[j]] =
                temporaryOffersList[i][this.visibleColumns[j]].name;
            }
          } else {
            if (columnName) {
              if (this.visibleColumns[j] == "validity") {
                let validity =
                  temporaryOffersList[i][this.visibleColumns[j]] == "0"
                    ? "Indefinida"
                    : "Temporal";
                temporaryContact[columnName] = validity;
              } else if (columnName.includes("Fecha")) {
                temporaryContact[columnName] = moment(
                  temporaryOffersList[i][this.visibleColumns[j]]
                ).format("DD/MM/YYYY");
              } else {
                temporaryContact[columnName] =
                  temporaryOffersList[i][this.visibleColumns[j]];
              }
            } else {
              temporaryContact[this.visibleColumns[j]] =
                temporaryOffersList[i][this.visibleColumns[j]];
            }
          }
        }

        formattedOffersList.push(temporaryContact);
      }

      this.JSONToCSVConvertor(
        formattedOffersList,
        `Listado de Ofertas - Página ${this.currentPage}`,
        true
      );
    },
    /**
     * Converts a JSON string to a CVS file (Excel readable file)
     *
     * @param      {string}  ReportTitle  The report title
     * @param      {boolean} ShowLabel    Flag that shows/hides the report title in the document
     */
    JSONToCSVConvertor(List, ReportTitle, ShowLabel) {
      let JSONData = JSON.stringify(List);

      //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData =
        typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;

      var CSV = "";
      //Set Report title in first row or line

      CSV += ReportTitle + "\r\n\n";

      //This condition will generate the Label/Header
      if (ShowLabel) {
        var row = "";
        //This loop will extract the label from 1st index of on array
        for (var index in arrData[0]) {
          //Now convert each value to string and comma-seprated
          row += index + ",";
        }

        row = row.slice(0, -1);

        //append Label row with line break
        CSV += row + "\r\n";
      }

      //1st loop is to extract each row
      for (var i = 0; i < arrData.length; i++) {
        var row = "";

        //2nd loop will extract each column and convert it in string comma-seprated
        for (var index in arrData[i]) {
          row += '"' + arrData[i][index] + '",';
        }

        row.slice(0, row.length - 1);

        //add a line break after each row
        CSV += row + "\r\n";
      }

      if (CSV == "") {
        alert("Invalid data");
        return;
      }

      //Generate a file name
      var fileName = ReportTitle;

      //Initialize file format you want csv or xls
      var uri = "data:text/csv;charset=utf-8," + escape(CSV);

      // Now the little tricky part.
      // you can use either>> window.open(uri);
      // but this will not work in some browsers
      // or you will not get the correct file extension

      //this trick will generate a temp <a /> tag
      var link = document.createElement("a");
      link.href = uri;

      //set the visibility hidden so it will not effect on your web-layout
      link.style = "visibility:hidden";
      link.download = fileName + ".csv";

      //this part will append the anchor tag and remove it after automatic click
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    sort(selectedColumn, isString) {
      if (this.sortBy == selectedColumn && !isString) {
        if (this.sortOrder == "ASC") {
          this.sortOrder = "DESC";
        } else {
          this.sortOrder = "ASC";
        }
      } else if (this.sortBy == selectedColumn && isString) {
        if (this.sortOrder == "DESC") {
          this.sortOrder = "ASC";
        } else {
          this.sortOrder = "DESC";
        }
      } else if (this.sortBy !== selectedColumn && !isString) {
        this.sortOrder = "DESC";
      } else if (this.sortBy !== selectedColumn && isString) {
        this.sortOrder = "ASC";
      }

      this.sortBy = selectedColumn;
      this.getOffers();
    },
    setCategories() {
      let service = this.serviceType.find((service) => {
        return service.id == this.selectedServiceType;
      });
      this.categories = service.categories;
    },
    verifyRequiredFields() {
      let fields =
        this.title &&
        this.description &&
        this.startDate &&
        this.comission_percent &&
        this.discount_percent &&
        this.selectedCategory &&
        this.selectedType &&
        this.selectedServiceType &&
        this.selectedProvider &&
        this.amount &&
        this.cost;

      let requiredPaymentLoans = false;

      if (this.selectedType == "1" && !this.days) {
        requiredPaymentLoans = true;
      } else if (this.selectedType == "2" && !this.fee) {
        requiredPaymentLoans = true;
      }

      let requiredDueDate = Number(this.validity) && !this.due_date;

      if (fields && !requiredPaymentLoans && !requiredDueDate) {
        this.createOffer();
      } else {
        sweetAlert("Oops...", "Â¡Llene todos los campos requeridos!", "error");
      }
    },
    pageChanged(page) {
      this.getOffers(page);
      this.currentPage = page;
      // Exec your response to server passing 'page' params as clicked button paging
    },
  },

  events: {
    "vuetable:action": function (action, data) {
      if (action == "view-item") {
        window.location.href = "/#!/offers/" + data.id + "/information";
      }
    },
    "vuetable:load-error": function (response) {
      console.log("Load Error: ", response);
    },
    "vuetable:loaded": function (response) {
      this.loadingTable = false;
    },
    "reload-table"() {
      this.getOffers(this.currentPage);
    },
    "updated-offer"() {
      this.getOffers(this.currentPage);
    },
  },

  computed: {
    isOfferIntern: function () {
      if (this.internOffer == true) {
        return (this.internOffer = "1");
      } else {
        return (this.internOffer = "0");
      }
    },

    /**cleanDaysOrFees: function() {
            if (this.selectedType == '1') {
                return this.days = '';
            } else {
                return this.fee = '';
            }
        },**/
    getDate: function () {
      var today = new Date();
      var date =
        today.getDate() +
        "/" +
        (today.getMonth() + 1) +
        "/" +
        today.getFullYear();
      return date;
    },
  },
};
</script>

<style scoped>
.txt-blue {
  color: #0000ee;
}
</style>



// WEBPACK FOOTER //
// list-offers.vue?27d5db85